<button type="button" class="btn ca-btn-icon collapse-expand-icon-button" (click)="toggleExpand()" data-uit="expand-collapse-table" [disabled]="disabled">
    <ca-icon
        [class.is-expanded]="expanded"
        [title]="expanded ? ('GENERAL.COLLAPSE' | translate) : ('GENERAL.EXPAND' | translate)"
        class="collapse-expand-icon"
        name="arrow-up"
        size="s"
    ></ca-icon>
</button>
